const firebaseConfig = {
  apiKey: "AIzaSyBxjjfZIo9b3LrTheaZJAkIx2jWgrWFY-k",
  authDomain: "mahima-motors-bike.firebaseapp.com",
  projectId: "mahima-motors-bike",
  storageBucket: "mahima-motors-bike.appspot.com",
  messagingSenderId: "1077121552121",
  appId: "1:1077121552121:web:a4b80797f620f00078dc28",
};

export default firebaseConfig;
